module.exports = __webpack_public_path__ + "img/990RecActive1.6770a8c5.png";